import _regeneratorRuntime from "E:\\monday-web\\node_modules\\@babel\\runtime\\regenerator\\index.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { toBoolean } from "./util.js";
import readAsArrayBuffer from "./readAsArrayBuffer";
import { AwesomeQR } from "../lib/awesome-qr";
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    qid: {
      type: String
    },
    correctLevel: {
      type: Number,
      "default": 1
    },
    size: {
      type: Number,
      "default": 200
    },
    margin: {
      type: Number,
      "default": 20
    },
    colorDark: {
      type: String,
      "default": "#000000"
    },
    colorLight: {
      type: String,
      "default": "#FFFFFF"
    },
    bgSrc: {
      type: String,
      "default": undefined
    },
    background: {
      type: String,
      "default": "rgba(0,0,0,0)"
    },
    backgroundDimming: {
      type: String,
      "default": "rgba(0,0,0,0)"
    },
    logoSrc: {
      type: String,
      "default": undefined
    },
    logoBackgroundColor: {
      type: String,
      "default": "rgba(255,255,255,1)"
    },
    gifBgSrc: {
      type: String,
      "default": undefined
    },
    logoScale: {
      type: Number,
      "default": 0.2
    },
    logoMargin: {
      type: Number,
      "default": 0
    },
    logoCornerRadius: {
      type: Number,
      "default": 8
    },
    whiteMargin: {
      type: [Boolean, String],
      "default": true
    },
    dotScale: {
      type: Number,
      "default": 1
    },
    autoColor: {
      type: [Boolean, String],
      "default": true
    },
    binarize: {
      type: [Boolean, String],
      "default": false
    },
    binarizeThreshold: {
      type: Number,
      "default": 128
    },
    callback: {
      type: Function,
      "default": function _default() {
        return undefined;
      }
    },
    bindElement: {
      type: Boolean,
      "default": true
    },
    backgroundColor: {
      type: String,
      "default": "#FFFFFF"
    },
    components: {
      "default": function _default() {
        return {
          data: {
            scale: 1
          },
          timing: {
            scale: 1,
            protectors: false
          },
          alignment: {
            scale: 1,
            protectors: false
          },
          cornerAlignment: {
            scale: 1,
            protectors: true
          }
        };
      }
    }
  },
  name: "vue-qr",
  data: function data() {
    return {
      imgUrl: ""
    };
  },
  watch: {
    $props: {
      deep: true,
      handler: function handler() {
        this.main();
      }
    }
  },
  mounted: function mounted() {
    this.main();
  },
  methods: {
    main: function main() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var gifImg, _logoImg, bgImg, logoImg;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.gifBgSrc) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return readAsArrayBuffer(_this.gifBgSrc);

              case 3:
                gifImg = _context.sent;
                _logoImg = _this.logoSrc;

                _this.render(undefined, _logoImg, gifImg);

                return _context.abrupt("return");

              case 7:
                bgImg = _this.bgSrc;
                logoImg = _this.logoSrc;

                _this.render(bgImg, logoImg);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    render: function render(img, logoImg, gifBgSrc) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var that;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this2; // if (this.$isServer) {
                //   return;
                // }
                // if (!this.AwesomeQR) {
                //   this.AwesomeQR = AwesomeQR;
                // }

                new AwesomeQR({
                  gifBackground: gifBgSrc,
                  text: that.text,
                  size: that.size,
                  margin: that.margin,
                  colorDark: that.colorDark,
                  colorLight: that.colorLight,
                  backgroundColor: that.backgroundColor,
                  backgroundImage: img,
                  backgroundDimming: that.backgroundDimming,
                  logoImage: logoImg,
                  logoScale: that.logoScale,
                  logoBackgroundColor: that.logoBackgroundColor,
                  correctLevel: that.correctLevel,
                  logoMargin: that.logoMargin,
                  logoCornerRadius: that.logoCornerRadius,
                  whiteMargin: toBoolean(that.whiteMargin),
                  dotScale: that.dotScale,
                  autoColor: toBoolean(that.autoColor),
                  binarize: toBoolean(that.binarize),
                  binarizeThreshold: that.binarizeThreshold,
                  components: that.components
                }).draw().then(function (dataUri) {
                  _this2.imgUrl = dataUri;
                  that.callback && that.callback(dataUri, that.qid);
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};